import React, { useState } from 'react';
import styles from './WriteReviewLink.module.css';
import ReviewModal from './ReviewModal';

interface WriteReviewLinkProps {
  productId: string;
  onReviewSubmitted: () => void;
}

const WriteReviewLink: React.FC<WriteReviewLinkProps> = ({ productId, onReviewSubmitted }) => {
  const [showModal, setShowModal] = useState(false);

  const openModal = () => {
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
  };

  return (
    <>
      <button onClick={openModal} className={styles.writeReviewLink}>
        Napiši recenziju
      </button>
      
      {showModal && (
        <ReviewModal 
          productId={productId} 
          onClose={closeModal} 
          onReviewSubmitted={onReviewSubmitted}
        />
      )}
    </>
  );
};

export default WriteReviewLink; 